exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".common-header[data-v-2f60a315]{.btn{background:#000;color:#fff;-webkit-box-shadow:0 2px 4px #d2d2d2;box-shadow:0 2px 4px #d2d2d2}}.item[data-v-2f60a315]{padding:.5rem;background:#fff}.item .mt-wrapper[data-v-2f60a315]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.item .mt[data-v-2f60a315]{height:2rem;line-height:2rem;-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1}.item .mt h2[data-v-2f60a315]{font-weight:700;font-size:.7rem}.item .time[data-v-2f60a315]{font-size:.6rem;color:grey}.item .mc[data-v-2f60a315]{padding-top:.5rem;line-height:1rem;font-size:.8rem}", ""]);

// exports
